import Message from "@/components/Message/Message";
import { useCompanySettings } from "@/hooks/useCompanySettings";
import { useUserSettings } from "@/hooks/useUserSettings";
import { ApiTwoTone, HddTwoTone, PieChartTwoTone, SlidersTwoTone } from "@ant-design/icons";
import { Image } from "antd";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/root-logo.png";
import ProfileMenu from "../ProfileMenu/ProfileMenu";
import { MenuCategory, useMenu } from "../RootMenu/RootMenu";
import styles from "./Topbar.module.scss";

export default function Topbar() {
  const { data: userSettings } = useUserSettings();
  const { data: companySettings } = useCompanySettings();

  const showBanner =
    userSettings &&
    ["root_admin", "root_user"].includes(userSettings?.role) &&
    companySettings?.company_type === "production";

  interface TopBarMenuItem {
    label: string;
    icon: ReactNode;
    url: string;
    category: MenuCategory;
  }

  const topBarMenuItems: TopBarMenuItem[] = [
    {
      label: "Collecting",
      icon: <HddTwoTone />,
      url: "/",
      category: "collecting",
    },
    {
      label: "Matching",
      icon: <ApiTwoTone />,
      url: "/matching",
      category: "matching",
    },
    {
      label: "Impact",
      icon: <PieChartTwoTone />,
      url: "/dashboard/corporate",
      category: "impact",
    },
  ];

  if (userSettings?.role === "root_admin") {
    topBarMenuItems.push({
      label: "Admin",
      icon: <SlidersTwoTone />,
      url: "/admin/users",
      category: "admin",
    });
  }

  const { category } = useMenu();

  return (
    <div className={styles.Topbar}>
      <div className={styles.left}>
        <Link
          to="/"
          className={styles.logo}
        >
          <Image
            className={styles.logoImage}
            src={logo}
            preview={false}
            alt="root-logo"
          />
        </Link>
        <div className={styles.menu}>
          {topBarMenuItems.map((item) => (
            <Link
              key={item.label}
              className={[styles.item, item.category === category && styles.active].join(" ")}
              to={item.url}
            >
              <span className={styles.icon}>{item.icon}</span>
              <span className={styles.label}>{item.label}</span>
            </Link>
          ))}
        </div>
        {showBanner && (
          <Message
            type="error"
            style={{ position: "sticky", top: 58, left: 0, width: "100%", zIndex: 997 }}
          >
            <strong>Logged in to {companySettings?.company_name}</strong>
          </Message>
        )}
      </div>
      <div className={styles.right}>
        <ProfileMenu />
      </div>
    </div>
  );
}
